import { fetchWidgetDetails } from '@/lib/api';

import { useLocalizedQuery } from './useLocalizedQuery';

import type { AccessScope } from '@/lib/auth';
import type { UseQueryOptions } from '@tanstack/react-query';

import type { Widget } from '@/lib/api/types';
import type { UUID } from '@/types';

export const useWidgetDetails = (
  siteId: UUID | undefined,
  widgetId: number | undefined,
  tenantId: string | undefined,
  scope: AccessScope,
  options?: Omit<UseQueryOptions<Widget, Error>, 'queryKey' | 'queryFn'>,
) => {
  const enabled =
    Boolean(siteId && widgetId && tenantId) && (options?.enabled ?? true);

  return useLocalizedQuery<Widget, Error>(
    ['widget-details', siteId, widgetId, tenantId, scope],
    (locale: string) =>
      fetchWidgetDetails(siteId!, widgetId!, tenantId!, { scope, locale }),
    { ...options, enabled },
  );
};
